import React from "react";
import { Box, IconButton, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface PdfViewerProps {
  fileUrl: string;
  onClose: () => void;
}

const PdfViewer: React.FC<PdfViewerProps> = ({ fileUrl, onClose }) => {
  return (
    <Modal open onClose={onClose}>
      <Box
        sx={{
          width: "100vw",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 9999,
        }}
      >
        {/* Close Button */}
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 20,
            right: 20,
            color: "white",
            backgroundColor: "rgba(0,0,0,0.5)",
            "&:hover": {
              backgroundColor: "rgba(0,0,0,0.8)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* PDF Viewer - Toolbar Visible, Download Disabled */}
        <iframe
          src={`${fileUrl}#toolbar=1&navpanes=0&scrollbar=1&view=FitH`}
          style={{
            width: "90%",
            height: "90%",
            border: "none",
            backgroundColor: "white",
          }}
          title="PDF Viewer"
        />
      </Box>
    </Modal>
  );
};

export default PdfViewer;
